import { ProviderInvoker, ProviderResult } from './orchestrator';

export const buildInvoker = <T>(
  name: string,
  fn: () => Promise<T | ProviderResult<T> | null>,
  timeoutMs?: number
): ProviderInvoker<T> => ({
  name,
  timeoutMs,
  invoke: async () => {
    const res = await fn();
    if (!res) return null;
    if (typeof (res as ProviderResult<T>).data !== 'undefined') {
      return res as ProviderResult<T>;
    }
    return { data: res as T, provider: name };
  },
});
